<template>
  <div class="card d-flex">
    <div class="col">
      <img src="@/assets/image/assets.svg" />
      <div class="tit">{{ $t("user.mine.total") }}</div>
      <div class="value">{{ balance.all }}</div>
    </div>
    <div class="col">
      <img src="@/assets/image/cap.svg" />
      <div class="tit">{{ $t("user.mine.networkCap") }}</div>
      <div class="value">{{ explorerInfo.target | formatCap }}</div>
    </div>
    <div class="col">
      <img src="@/assets/image/height.svg" />
      <div class="tit">{{ $t("user.mine.lastHeight") }}</div>
      <div class="value">{{ explorerInfo.height }}</div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    explorerInfo: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  computed: {
    ...mapState("wallet", ["balance"]),
  },
  filters: {
    formatCap(val) {
      if (!val) return "";
      return (val / 1024).toFixed(8);
    },
  },
};
</script>
<style lang="scss" scoped>
.card {
  padding: 28px 0;
}
.col {
  flex: 1;
  text-align: center;
  .tit {
    font-size: 14px;
    font-weight: 400;
    color: #656161;
    line-height: 14px;
    margin-top: 13px;
  }
  .value {
    font-size: 40px;
    font-weight: 500;
    color: #e73419;
    line-height: 40px;
    margin-top: 20px;
  }
}
@media screen and (max-width: 768px) {
  .card {
    flex-direction: column;
    padding:4px 20px;
    .col {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 0;
      .tit {
        font-weight: 600;
        color: #060606;

        margin-top: 0;
      }
      .value {
        margin-top: 0;
        font-size: 14px;
        font-weight: 600;
        line-height: 1;
        color: #dc472a;
      }
      img {
        display: none;
      }
      &:not(:last-child) {
        border-bottom: 1px solid rgba(8, 8, 7, 0.1);
      }
    }
  }
}
</style>
